<div class="bg-white">
  <div
    class="block md:flex justify-between items-center mb-4 md:mb-6 xl:mb-8"
    *ngIf="!showAll"
  >
    <h2 class="font-light font-accent text-4.5xl xl:text-4.5xl">
      {{ title }}
    </h2>
    <div class="flex justify-between items-center">
      <a class="text-primary-600 font-bold">Tout afficher</a>
      <div class="ml-6 hidden xl:block">
        <app-rounded-icon-button
          *ngIf="!hidePrevBtn"
          icon="icon-arrow-left mr-3"
          color="primary"
          [outlined]="true"
          (onClick)="prevPage()"
        ></app-rounded-icon-button>
        <app-rounded-icon-button
          *ngIf="!hideNextBtn"
          icon="icon-arrow-right"
          color="primary"
          [outlined]="true"
          (onClick)="nextPage()"
        ></app-rounded-icon-button>
      </div>
    </div>
  </div>
  <div
    class="gap-2 md:3 xl:gap-4 xl:overflow-x-hidden"
    [ngClass]="{
      'flex overflow-x-auto': !showAll,
      'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4': showAll,
    }"
  >
    <div
      class="block min-w-256 origin-top-right xl:min-w-24"
      [ngClass]="{ 'flex-basis-25': !showAll }"
      [id]="'slide_' + (index + 1)"
      *ngFor="let shop of shops; let index = index"
    >
      <app-push-shop-card-v2-atom
        [title]="shop[ShopKeys.Name]"
        [distance]="shop[ShopKeys.Distance]"
        [stars]="shop[ShopKeys.Stars]"
        [availableAt]="shop[ShopKeys.AvailableAt]"
        [isFavorite]="shop[ShopKeys.Favorite]"
        [imgUrl]="shop[ShopKeys.OverviewImage]?.url"
        [linkUrl]="shopsService.getUrl(shop)"
        (favoriteChange)="favoriteChange.emit($event)"
      ></app-push-shop-card-v2-atom>
    </div>
  </div>
</div>
